import { CONST } from "../CONST";
import { MinigameScene } from "./generic/MinigameScene";

export class BirthScene extends MinigameScene {
    //Images
    private baby !: Phaser.GameObjects.Image;
    private clicker !: Phaser.GameObjects.Image;
    private mamice : Phaser.GameObjects.Image[] = [];    
    private swing !: Phaser.GameObjects.Image;
    private winAudio !: Phaser.Sound.BaseSound;


    //values
    private clickableWidth = 100;
    private missTimePunishment = 250;
    private clickerSwingTime = 825; //in ms

    private swingStartX = 277;
    private swingEndX = 807;

    private babyPositions : object[] = [{rot: 80, x: 242, y: 257},
        {rot: 90, x: 262, y: 263},
        {rot: 89, x: 275, y: 263},
        {rot: 87, x: 289, y: 265},
        {rot: 87, x: 301, y: 263}];

    //logic vars
    private clickerMovingRight !: boolean;
    private swingTimer !: number;
    private hits !: number;


    constructor(){
        super ({
            sceneName: CONST.SCENES.BIRTH,
            duration: 7500,
            startScreenColor: 0xC1FFDB,
            startText: "GET BORN!",
            startTextColor: 0x323232,
            endScreen: CONST.BIRTH.END,
            nextScene: CONST.SCENES.TALK,
            endButtons: {
                normalNoSkip: {x: 426.5, y: 411, scale: 1.30},
                normalWithSkip: {x: 283, y: 411, scale: 1.30},
                skip: {x: 570, y: 411, scale: 1.30}
            }
          })
    }
    _init(){
        this.clickerMovingRight = true;
          this.swingTimer = 0;
          this.hits = 0;
          this.mamice = [];
    }

    _preload(){
    }

    _create(){
        let background = this.add.image(0,0, CONST.BIRTH.BACKGROUND).setOrigin(0, 0);
        background.setInteractive();
        background.on("pointerdown", ()=>{
            this.handleClick();
        })

        this.baby = this.add.image(301, 266, CONST.BIRTH.BABY).setAngle(87.5).setScale(0.67, 0.67);
        this.add.image(145, 433, CONST.BIRTH.PUSH);
        this.add.image(717, 262, CONST.BIRTH.STROLLER).setDepth(100);
        this.swing = this.add.image(542, 429, CONST.BIRTH.SWING);
        this.clicker = this.add.image(542, 429, CONST.BIRTH.CLICKER);

        this.createMamice(226, 299);
        this.setMamicaState(this.hits);

        this.winAudio = this.sound.add(CONST.AUDIO.CRY, {
            loop: false
        });
    }

    private createMamice(x: number, y: number){
        var mamicePaths = [CONST.BIRTH.MAMICA1, CONST.BIRTH.MAMICA2, CONST.BIRTH.MAMICA3, CONST.BIRTH.MAMICA4, CONST.BIRTH.MAMICA5];
        mamicePaths.forEach(path => {
            this.mamice.push(this.add.image(x, y, path).setVisible(false).setDepth(150));
        });
    }

    private setMamicaState(index: number){
        if (index >= this.mamice.length){
            this.triggerWin();
            return;
        }

        for (var i = 0; i < this.mamice.length; i++){
           this.mamice[i].setVisible(i===index);
        }

        //console.log("setting mamica state" + index);
        this.baby.setPosition(this.babyPositions[index].x, this.babyPositions[index].y)
                 .setAngle(this.babyPositions[index].rot);
    }

    _update(time: number, delta: number){
        if (this.isCurrentState(CONST.GAMESTATE.PLAYING)) {
            this.moveClicker(delta);
        } else if (this.isCurrentState(CONST.GAMESTATE.WIN)){
            if (!this.babyFollow) return;

            this.babyFollow.update(delta);
        };
    }

    private moveClicker(delta: number){
            if (this.clickerMovingRight){
                this.swingTimer += delta / this.clickerSwingTime;

                if (this.swingTimer >= 1){
                    this.clickerMovingRight = !this.clickerMovingRight;
                    this.swingTimer = 1;
                }
            } else {
                this.swingTimer -= delta / this.clickerSwingTime;

                if (this.swingTimer <= 0){
                    this.clickerMovingRight = !this.clickerMovingRight;
                    this.swingTimer = 0;
                }
            }
            this.clicker.x = Phaser.Math.Interpolation.SmoothStep(this.swingTimer, this.swingStartX, this.swingEndX);
    }

    private handleClick(){
        if (this.isCurrentState(CONST.GAMESTATE.PLAYING)){
            //console.log("clicked within limits " + this.isClickerWithinLimits());
            if (this.isClickerWithinLimits()){
                this.hits++;
                this.setMamicaState(this.hits);
            } else {
                this.changeGameplayTimerDuration(-this.missTimePunishment);
                this.cameras.main.flash(200, 255, 64, 43);
            }
        }
    }

    private isClickerWithinLimits() : boolean{
        return Phaser.Math.Difference(this.clicker.x, this.swing.x) < this.clickableWidth;
    }

    _timeout(){
        this.loseGame();
    }

    _afterLoss(){
    }

    _afterWin(){
        this.winAudio.stop();
   }

    private triggerWin(){
        this.winGame(1500);
        
        this.winAnim();
        this.winAudio.play();
    }

    private winAnim(){
        var path = new Phaser.Curves.Path(310, 256).splineTo([527,129,733,246]);

        this.babyFollow = this.add.follower(path, 0, 0, CONST.BIRTH.BABY).setAngle(87.5).setScale(0.67, 0.67);
    
        this.babyFollow.startFollow({
            positionOnPath: true,
            duration: 1000,
            rotateToPath: false,
            from: 0,
            to: 1
        });

        this.babyFollow.lifeTimer = 0;

        this.babyFollow.update = function(delta: number) {
            this.lifeTimer += delta;
            if (this.lifeTimer > 1000) return; 

            this.setAngle(this.angle + 360*delta/1000);
            //console.log("baby update");
        }

        this.baby.setVisible(false);
    }
}